export const sortArray = (arr: any) => arr.sort((a: any, b: any) => +a.bet - +b.bet).reverse()